export interface UserInteractionEvent {
    event: EventName;
    event_data: {
        type: UserInteractionType; // the type of user interaction
        component_name: string; // the event target component's innerHTML or alt text (if img)
        component_type: string; // "Button" | "Internal Link" | "External Link"
        parent_name?: string; // the parent node's primary identifier text (e.g. main heading or label)
        parent_type?: TrackedParentNode;
        current_path: string; // url of the event location
        next_path?: string; // url of the next location if the event is a link
        // Further discussion is needed to determine the best way to implement this so that it is helpful to the business
        // (experimental) - the location of the event target relative to the page
        // window_location?: {
        //     offset_top?: number;
        //     offset_left?: number;
        // };
    };
}

export enum EventName {
    PAGE_VIEW = `pageview`,
    USER_INTERACTION = `user_interaction`,
}

export enum UserInteractionType {
    BUTTON_CLICK = `Button Click`,
    LINK_CLICK = `Link Click`,
    FORM_SUBMISSION = `Form Submission`,
}

// The types of nodes that are tracked as parents of user interactions
export type TrackedParentNode =
    | `Navigation`
    | `Hero`
    | `Single_Column_Dynamic_Form`
    | `Single_Column`
    | `Single_Col_Custom_Btns`
    | `Two_Column`
    | `Two_Column_Text_Image`
    | `Two_Column_Text_Media`
    | `Three_Column`
    | `Three_Column_Narrow`
    | `Four_Column`
    | `Promo_Bar` // Parent Name is undefined
    | `Login_Bar` // Parent Name is undefined
    | `Article_Links` // Parent Name is undefined
    | `Footer`
    | `Unknown_Parent_Node`;
